import { render } from "./RedirectPage.vue?vue&type=template&id=648e82ba&scoped=true&ts=true"
import script from "./RedirectPage.vue?vue&type=script&lang=ts"
export * from "./RedirectPage.vue?vue&type=script&lang=ts"

import "./RedirectPage.vue?vue&type=style&index=0&id=648e82ba&scoped=true&lang=css"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648e82ba"]])

export default __exports__